export default __webpack_public_path__ + "static/media/group-all-off.4a2e51c2.svg";